import React from "react";
import cx from "classnames";
import styles from "./styles.module.scss";

function RadioGroup({ value, options, name, onChange, stacked }) {
  return (
    <>
      <div
        className={cx(
          {
            [styles.content]: !stacked
          },
          styles.newQuiz
        )}
      >
        {options.map((option, i) => {
          const id = `${name}${option.value}`;
          return (
            <div
              className={cx(
                {
                  [styles.option]: !stacked,
                  [styles.optionStacked]: stacked
                },
                styles.newQuiz
              )}
              key={id}
            >
              <input
                type="radio"
                value={option.value}
                name={name}
                id={id}
                checked={option.value === value}
                onChange={() => onChange(option.value)}
                className={cx(styles.input, styles.newQuiz)}
                tabIndex={i + 1}
                autoFocus={i === 0}
              />
              <label className={cx(styles.label, styles.newQuiz)} htmlFor={id}>
                {option.label}
              </label>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default RadioGroup;
